// Apolo IDE — ChatRefBlockBody (sprint plan-tab-v1, E3 placeholder).
//
// Bloco que referencia uma conversa do chat copiloto. Real wiring com
// useConversations chega no E5. V1: mostra snippet salvo + CTA.

import { useState } from 'react';
import { MessageSquare, ExternalLink } from 'lucide-react';

export default function ChatRefBlockBody({ payload, onChange, accent }) {
  const [snippet, setSnippet] = useState(payload.snippet || '');
  return (
    <div className="flex h-full w-full flex-col p-3">
      <div className="mb-2 flex items-center gap-1.5 text-[10px] uppercase tracking-wide" style={{ color: accent }}>
        <MessageSquare size={11} aria-hidden="true" />
        <span>Trecho de conversa</span>
        {payload.conversation_id ? (
          <button
            type="button"
            className="ml-auto inline-flex items-center gap-1 rounded px-1.5 py-0.5 text-[10px] text-apolo-textSecondary hover:bg-apolo-surface2"
            onClick={() => window.dispatchEvent(new CustomEvent('apolo:openChat', { detail: { conversationId: payload.conversation_id } }))}
            aria-label="Abrir conversa"
          >
            <ExternalLink size={9} /> abrir
          </button>
        ) : null}
      </div>
      <textarea
        value={snippet}
        onChange={(e) => setSnippet(e.target.value)}
        onBlur={() => onChange({ ...payload, snippet })}
        placeholder="Cole aqui um trecho de conversa relevante…"
        className="flex-1 resize-none rounded-md border border-apolo-borderSubtle/40 bg-apolo-bg p-2 text-xs italic leading-relaxed text-apolo-textPrimary placeholder:text-apolo-textPlaceholder focus:border-apolo-plan-accentBorder focus:outline-none"
      />
    </div>
  );
}
